export function filterNumber(str) {
    str += '';
    const rgNotNumber = new RegExp('\\D', 'g');
    const numberStr = str.replace(rgNotNumber, '');
    return numberStr;
}
export function toPascalCase(str) {
    if (!str)
        return str;
    return str.replace(new RegExp('\\w\\S*', 'g'), (m) => {
        return m.charAt(0).toUpperCase() + m.substring(1).toLowerCase();
    });
}
export function formatCurrency(price) {
    if (typeof price === 'number') {
        if (price < 0) {
            return '-$' + Math.abs(price).toFixed(2);
        }
        else {
            return '$' + price.toFixed(2);
        }
    }
    return price;
}
export function formatDate(input) {
    const date = new Date(input);
    return date.getMonth() + 1 + '/' + date.getDate();
    // if (typeof (price) === 'number') {
    //   return '$' + price.toFixed(2)
    // }
    // return price
}
export function getUrlParam(name) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    const r = window.location.search.substring(1).match(reg);
    if (r != null)
        return decodeURIComponent(r[2]);
    return '';
}
export const trim = (str) => {
    return str.replace(/(^\s*)|(\s*$)/g, '');
};
/**
 * @method 过滤非数字的字符
 * @returns 返回过滤后的数字
 * @example ec.util.onlyNumber('12a3') 返回123
 */
export const onlyNumber = (text) => {
    text = trim(text);
    if (text.length > 0) {
        text = text.replace(/[^0-9]/g, '');
    }
    return text.replace(/\b(0+)/gi, '');
};
/**
 * @method 去除字符串中的html标签
 * @returns 过滤后的字符串
 */
export const removeHtmlTag = (text, htmlDecoding = false) => {
    if (htmlDecoding) {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        return doc.documentElement.textContent ?? '';
    }
    else {
        return text.replace(/<[^>]+>/g, '');
    }
};
